<template>
  <v-autocomplete
    prepend-inner-icon="mdi-flag"
    label="Nationality"
    item-text="node.name"
    item-value="node.name"
    v-model="selected"
    :items="items"
    @change="onChange"
    :outlined="outlined"
  ></v-autocomplete>
</template>

<script>
import gql from "graphql-tag";
export const query = gql`
  {
    nationalities {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
export default {
  props: {
    value: {
      type: String,
      default: () => ""
    },
    outlined: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  computed: {
    items() {
      return this.nationalities && this.nationalities.edges.length > 0
        ? [...this.nationalities.edges]
        : [];
    }
  },
  methods: {
    onChange(event) {
      if (event) {
        this.$emit("input", event);
      }
    },
    selectByName(name) {
      const found = this.items.find(i => i.node.name == name);
      if (found) {
        this.selected = found.node.name;
      }
    }
  },
  watch: {
    value(newVal) {
      this.selectByName(newVal);
    }
  },
  apollo: {
    nationalities: {
      query,
      variables() {
        return {};
      },
      result({ data, loader, networkStatus }) {
        if (this.value != "") {
          this.selectByName(this.value);
        }
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/NationalityListSelect.vue